<template>
  <div class="row justify-content-center">
    <base-button
      class="col px-3 m-2 btn-secondary"
      :type="buttonColor(value)"
      v-for="value in values"
      :key="value"
      size="sm"
      :outline="value !== formData"
      @click="formData = value"
    >
      {{ value }}
    </base-button>
  </div>
</template>

<script>
export default {
  name: "LikertScaleAvaliationItemStrategy",
  props: {
    avaliationItem: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    value: {},
  },
  methods: {
    buttonColor(value) {
      const referenceValue = (this.max - this.min) / 3

      if (value - this.min < referenceValue) {
        return 'danger'
      }

      if (this.max - value < referenceValue) {
        return 'success'
      }

      return 'warning'
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    config() {
      return this.avaliationItem.config || {};
    },
    min() {
      return this.config.min_value || 1
    },
    max() {
      return this.config.max_value || 10
    },
    values() {
      return Array.from({ length: this.max - this.min + 1 }, (_, i) => i + this.min)
    },
  },
}
</script>

